import React from "react";
import {
  Grid,
  TextField,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import { Formik, Form, FieldArray } from "formik";
import * as Yup from "yup";
import DeleteIcon from "@mui/icons-material/Delete";

const validationSchema = Yup.object().shape({
  education: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("College name is required"),
      percentage: Yup.string().required("Percentage is required"),
      passingYear: Yup.string().required("Passing year is required"),
    })
  ),
});

const EducationDetailEditForm = ({ userDetails, onCancel, onSave }) => {
  const initialValues = {
    education: userDetails?.profile_data?.education || [
      { name: "", percentage: "", passingYear: "" },
    ],
  };

  const handleSubmit = (values) => {
    const payload = {
      id: userDetails.id,
      profile: {
        education: values.education,
      },
    };
    onSave(payload);
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({ values, errors, touched, handleChange, handleBlur }) => (
        <Form>
          <FieldArray name="education">
            {({ push, remove }) => (
              <Grid container spacing={2}>
                {values.education.map((edu, index) => (
                  <React.Fragment key={index}>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        name={`education[${index}].name`}
                        label="College Name"
                        value={edu.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.education &&
                          touched.education[index]?.name &&
                          Boolean(errors.education?.[index]?.name)
                        }
                        helperText={
                          touched.education &&
                          touched.education[index]?.name &&
                          errors.education?.[index]?.name
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        fullWidth
                        name={`education[${index}].percentage`}
                        label="Percentage"
                        value={edu.percentage}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.education &&
                          touched.education[index]?.percentage &&
                          Boolean(errors.education?.[index]?.percentage)
                        }
                        helperText={
                          touched.education &&
                          touched.education[index]?.percentage &&
                          errors.education?.[index]?.percentage
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        fullWidth
                        name={`education[${index}].passingYear`}
                        label="Passing Year"
                        value={edu.passingYear}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.education &&
                          touched.education[index]?.passingYear &&
                          Boolean(errors.education?.[index]?.passingYear)
                        }
                        helperText={
                          touched.education &&
                          touched.education[index]?.passingYear &&
                          errors.education?.[index]?.passingYear
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={2} display="flex" alignItems="center">
                      <IconButton onClick={() => remove(index)} color="error">
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </React.Fragment>
                ))}

                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    onClick={() =>
                      push({ name: "", percentage: "", passingYear: "" })
                    }
                  >
                    Add More
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                    <Button variant="outlined" onClick={onCancel}>
                      Cancel
                    </Button>
                    <Button type="submit" variant="contained" color="primary">
                      Save
                    </Button>
                    
                  </Box>
                </Grid>
              </Grid>
            )}
          </FieldArray>
        </Form>
      )}
    </Formik>
  );
};

export default EducationDetailEditForm;
